'use client';
import Image from 'next/image';
import arrow from '/public/assets/arrow.svg';
import Title from '@/components/Title';
import { useTranslations } from 'next-intl';

const Returns = () => {
  const t = useTranslations('return');
  const descriptionHtml = t.raw('description');
  const return_policy_description = t.raw('return_policy.return_policy_description');
  const return_policy_1 = t.raw('return_policy.return_policy_1');
  const return_policy_2 = t.raw('return_policy.return_policy_2');
  const return_policy_3 = t.raw('return_policy.return_policy_3');
  const return_policy_4 = t.raw('return_policy.return_policy_4');

  const return_process = t.raw('return_process.return_process');
  const return_process_1 = t.raw('return_process.return_process_1');
  const for_guest_order = t.raw('return_process.for_guest_order');
  const return_process_2 = t.raw('return_process.return_process_2');
  const return_process_3 = t.raw('return_process.return_process_3');
  const return_process_4 = t.raw('return_process.return_process_4');

  const damaged_goods = t.raw('damaged_goods.damaged_goods');
  const damaged_goods_description = t.raw('damaged_goods.damaged_goods_description');

  const pre_paid_label = t.raw('pre_paid_label.pre_paid_label');
  const pre_paid_label_description = t.raw('pre_paid_label.pre_paid_label_description');
  const pre_paid_label_1 = t.raw('pre_paid_label.pre_paid_label_1');
  const pre_paid_label_2 = t.raw('pre_paid_label.pre_paid_label_2');
  const pre_paid_label_3 = t.raw('pre_paid_label.pre_paid_label_3');

  const customer_service = t.raw('customer_service.customer_service');
  const customer_service_description = t.raw('customer_service.customer_service_description');

  return (
    <div className="terms-of-use mx-auto mt-28 max-w-[718px] p-4">
      <div className="mb-6">
        <Title title={t('title')} />
      </div>
      <p className="pb-6 text-sm text-clr-6A dark:text-clr-a4" dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
      <div>
        <ol>
          <li>
            <h1 className="mb-3 text-base font-bold text-clr-2e dark:text-white">{t('return_policy.return_policy')}</h1>
            <p
              className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: return_policy_description }}
            />
            <div className="flex flex-col gap-3 pb-6">
              <div className="flex items-start text-sm text-clr-6A dark:text-clr-a4">
                <Image src={arrow} alt="" />
                <h1 dangerouslySetInnerHTML={{ __html: return_policy_1 }} />
              </div>
              <div className="flex items-start text-sm text-clr-6A dark:text-clr-a4">
                <Image src={arrow} alt="" />
                <h1 dangerouslySetInnerHTML={{ __html: return_policy_2 }} />
              </div>
              <div className="flex items-start text-sm text-clr-6A dark:text-clr-a4">
                <Image src={arrow} alt="" />
                <h1 dangerouslySetInnerHTML={{ __html: return_policy_3 }} />
              </div>
            </div>
            <h1
              className="pb-6 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: return_policy_4 }}
            />
          </li>
        </ol>

        <h1
          className="mb-3 text-base font-bold text-clr-2e dark:text-white"
          dangerouslySetInnerHTML={{ __html: return_process }}
        />
        <ol className="list-decimal pl-5">
          <li>
            <p
              className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: return_process_1 }}
            />
          </li>
          <li>
            <p
              className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: for_guest_order }}
            />
          </li>

          <li>
            <p
              className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: return_process_2 }}
            />
          </li>
          <li>
            <p
              className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: return_process_3 }}
            />
          </li>
          <li>
            <p
              className="pb-6 text-sm text-clr-6A dark:text-clr-a4"
              dangerouslySetInnerHTML={{ __html: return_process_4 }}
            />
          </li>
        </ol>

        <h1 className="mb-3 text-base font-bold text-clr-2e dark:text-white">{damaged_goods}</h1>
        <p
          className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
          dangerouslySetInnerHTML={{ __html: damaged_goods_description }}
        />

        <h1
          className="mb-3 text-base font-bold text-clr-2e dark:text-white"
          dangerouslySetInnerHTML={{ __html: pre_paid_label }}
        />
        <p className="pb-3 text-sm text-clr-6A dark:text-clr-a4">{pre_paid_label_description}</p>

        <div className="flex flex-col gap-3 pb-6">
          <div className="flex items-start text-sm text-clr-6A dark:text-clr-a4">
            <Image src={arrow} alt="" />
            <h1 dangerouslySetInnerHTML={{ __html: pre_paid_label_1 }} />
          </div>
          <div className="flex items-start text-sm text-clr-6A dark:text-clr-a4">
            <Image src={arrow} alt="" />
            <h1 dangerouslySetInnerHTML={{ __html: pre_paid_label_2 }} />
          </div>
          <div className="flex items-start text-sm text-clr-6A dark:text-clr-a4">
            <Image src={arrow} alt="" />
            <h1 dangerouslySetInnerHTML={{ __html: pre_paid_label_3 }} />
          </div>
        </div>

        <h1 className="mb-3 text-base font-bold text-clr-2e dark:text-white"> {customer_service}</h1>
        <p
          className="pb-3 text-sm text-clr-6A dark:text-clr-a4"
          dangerouslySetInnerHTML={{ __html: customer_service_description }}
        />
      </div>
    </div>
  );
};

export default Returns;
